(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FbSelectService', FbSelectService);

    function FbSelectService(lodash, $compile, $timeout, $templateCache) {
        return {
            initTemplateCall: initTemplateCall
        };

        function initTemplateCall(elementOptions, additionalOptions) {
            if (lodash.has(elementOptions, 'template.item')) {
                lodash.set(additionalOptions, 'render.item', renderItem);
            }
            if (lodash.has(elementOptions, 'template.option')) {
                lodash.set(additionalOptions, 'render.option', renderOption);
            }
            if (lodash.has(elementOptions, 'template.option_create')) {
                lodash.set(additionalOptions, 'render.option_create', renderOptionCreate);
            }
            if (lodash.has(elementOptions, 'template.optgroup_header')) {
                lodash.set(additionalOptions, 'render.optgroup_header', renderOptgroupHeader);
            }
            if (lodash.has(elementOptions, 'template.optgroup')) {
                lodash.set(additionalOptions, 'render.optgroup', renderOptgroup);
            }

            function renderItem(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.item', {html: '', schema: []}));
            }

            function renderOption(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.option', {html: '', schema: []}));
            }

            function renderOptionCreate(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.create', {html: '', schema: []}));
            }

            function renderOptgroupHeader(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.optgroup_header', {html: '', schema: []}));
            }

            function renderOptgroup(data, escape) {
                return render(data, escape, lodash.get(elementOptions, 'template.optgroup', {html: '', schema: []}));
            }

            function render(data, escape, template) {
                if (lodash.isEmpty(template.html)) {
                    if (lodash.has(template, 'htmlTemplateUrl')) {
                        template.html = $templateCache.get(template.htmlTemplateUrl);
                    }
                }

                const result = template.schema.reduce((previous, current) => {
                    const dataEscaped = escape(lodash.get(data, current, ''));
                    const replaceKey = `#${current}#`;
                    return previous.replace(replaceKey, dataEscaped);
                }, template.html);

                return TemplateEngine(result, lodash.pick(data, template.schema || []));
            }

            var TemplateEngine = function(html, options) {
                var re = /<@([^@>]+)?@>/g, reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, code = 'var r=[];\n', cursor = 0, match;
                var add = function(line, js) {
                    js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
                        (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
                    return add;
                }
                while(match = re.exec(html)) {
                    add(html.slice(cursor, match.index))(match[1], true);
                    cursor = match.index + match[0].length;
                }
                add(html.substr(cursor, html.length - cursor));
                code += 'return r.join("");';
                return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
            }

        }


    }
})();